import { FC, ReactNode, useEffect, useRef } from 'react'
import {
  StyleModalCard,
  StyleModalCardBody,
  StyleModalCardHeader,
  StyleModalCardTitle,
  StyleModalOverlay,
  StyleModalWrapper,
  StyleCrossIconWrapper,
} from './style'
import Svg from '../svg'
interface ModalProps {
  visible: boolean
  title?: string
  children?: ReactNode
  onClose?: () => void
  width?: number | string
  styleModal?: string
  hasCross?: boolean
}

const Modal: FC<ModalProps> = ({
  visible,
  children,
  title,
  onClose,
  width = 500,
  styleModal,
  hasCross = true,
}) => {
  const modalRef = useRef<HTMLDivElement>(null)
  const onClickOutside = (event: MouseEvent) => {
    if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
      onClose && onClose()
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', onClickOutside)
    return () => {
      document.removeEventListener('mousedown', onClickOutside)
    }
  }, [])
  return (
    <>
      {!!visible && (
        <StyleModalWrapper>
          <StyleModalOverlay>
            <StyleModalCard ref={modalRef} size={width} styleModal={styleModal}>
              {!!hasCross && (
                <StyleCrossIconWrapper
                  onClick={() => {
                    onClose && onClose()
                  }}
                >
                  <Svg svg="cross" size={14} />
                </StyleCrossIconWrapper>
              )}

              {!!title && (
                <StyleModalCardHeader>
                  <StyleModalCardTitle>{title}</StyleModalCardTitle>
                </StyleModalCardHeader>
              )}
              <StyleModalCardBody>{children}</StyleModalCardBody>
            </StyleModalCard>
          </StyleModalOverlay>
        </StyleModalWrapper>
      )}
    </>
  )
}
export default Modal
